/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

const Config = {
    Recollect: {
        script: { src: "" },
        style: {
            href: "",
        },
    },
    Userway: {
        src: "https://cdn.userway.org/widget.js",
        account: "46g6mAw7kt",
    },
    SEO: {
        url: "https://www.nsbylaw.ca/",
        website_title: "North Shore Dispute Registry",
        description: "This is the official website for North Shore Dispute Registry.",
        website_image: "https://images.dnv.org/images/dnv-air-deepcove.jpg",
        keywords: "North Shore Dispute Registry",
    },
    google_site_verification: "+nxGUDJ4QpAZ5l9Bsjdi102tLVC21AIh5d1Nl23908vVuFHs34=",
    recaptcha_site_key: "6LenVeEpAAAAAHBfaB6YaiuxZewd_XN-5LkeT_2a",
    dateFormat: {
        date: "MMMM DD, YYYY",
        date_new: "dddd, MMM D",
        date_short: "ddd, MMM D",
        event_date: "dddd, MMM D",
        date_fullday: "dddd MMMM D, YYYY",
        date_fullday_with_time: "dddd MMMM D, YYYY h:mma",
        time: "h:mma",
        datetime: "MMMM DD, YYYY h:mma",
        date_short_no_year: "MMM D",
        event_date_month: "MMM",
        event_date_date: "D",
        date_shortday: "ddd MMMM D, YYYY",
        date_fullday_short: "ddd MMMM D, YYYY",
        date_no_dow: "MMMM D, YYYY",
        date_short_month: "MMM D, YYYY"
    },
    earliest_last_mod: "2024-08-10",
};

export { Config };
